module.exports = __webpack_public_path__ + "img/icon_01.2d50f648.png";